import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { SITE, waLink, img, IMAGES } from "../data/site";
import { Phone } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist. Book a taxi in Jodhpur with Blue City Taxi." path="/404" />
      <section className="relative bg-navy min-h-[70vh] flex items-center overflow-hidden grain">
        <img src={img(IMAGES.heroJodhpur, 1600)} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="relative max-w-2xl mx-auto px-6 py-24 text-center">
          <p className="font-heading text-7xl font-extrabold text-gold">404</p>
          <h1 className="mt-3 font-heading text-3xl font-extrabold text-white">This road doesn't exist</h1>
          <p className="mt-3 text-white/70 text-sm">But we know every road that does — across Jodhpur and all of Rajasthan.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" data-testid="nf-home-btn" className="rounded-full bg-gold text-navy font-bold px-7 py-3 text-sm hover:bg-white transition-colors">Back to Home</Link>
            <a href={`tel:${SITE.phoneTel}`} data-testid="nf-call-btn" className="rounded-full border border-white/30 text-white font-bold px-7 py-3 text-sm inline-flex items-center gap-2 hover:bg-white/10"><Phone size={15} /> Call Us</a>
            <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="nf-wa-btn" className="rounded-full bg-wa text-white font-bold px-7 py-3 text-sm inline-flex items-center gap-2"><FaWhatsapp size={15} /> WhatsApp</a>
          </div>
        </div>
      </section>
    </>
  );
}
